import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  ", "\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &:hover {\n    color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border-top: ", ";\n      border-right: ", ";\n      border-bottom: ", ";\n      border-left: ", ";\n      background-color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      border-top: ", ";\n      border-right: ", ";\n      border-bottom: ", ";\n      border-left: ", ";\n      background-color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border-top: ", ";\n        border-right: ", ";\n        border-bottom: ", ";\n        border-left: ", ";\n        background-color: ", ";\n        outline: none;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        border-top: ", ";\n        border-right: ", ";\n        border-bottom: ", ";\n        border-left: ", ";\n        background-color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  width: 100%;\n  outline: none;\n  box-sizing: border-box;\n  height: ", ";\n  border-top: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  ", "\n  ", "\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n    color: ", ";\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:focus-within {\n    ", "\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { layout, right, left, space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';
var StyledInput = styled.div(_templateObject(), layout);
var HtmlInput = styled.input(_templateObject2(), themeGet('input.fontSize'), function (props) {
  return themeGet("input.sizes.".concat(props.size));
}, themeGet('input.border.top'), themeGet('input.border.right'), themeGet('input.border.bottom'), themeGet('input.border.left'), themeGet('input.borderRadius'), themeGet('input.backgroundColor'), space, layout, function (props) {
  return props.disabled ? themeGet('input.disabled.placeHolderColor') : themeGet('input.placeHolderColor');
}, themeGet('input.disabled.color'), function (props) {
  return !props.error && !props.disabled && css(_templateObject3(), themeGet('input.hover.border.top'), themeGet('input.hover.border.right'), themeGet('input.hover.border.bottom'), themeGet('input.hover.border.left'), themeGet('input.hover.backgroundColor'));
}, function (props) {
  return !props.error && css(_templateObject4(), themeGet('input.focus.border.top'), themeGet('input.focus.border.right'), themeGet('input.focus.border.bottom'), themeGet('input.focus.border.left'), themeGet('input.focus.backgroundColor'));
}, function (props) {
  return props.disabled && css(_templateObject5(), themeGet('input.disabled.border.top'), themeGet('input.disabled.border.right'), themeGet('input.disabled.border.bottom'), themeGet('input.disabled.border.left'), themeGet('input.disabled.backgroundColor'));
}, function (props) {
  return props.error && css(_templateObject6(), themeGet('input.error.border.top'), themeGet('input.error.border.right'), themeGet('input.error.border.bottom'), themeGet('input.error.border.left'), themeGet('input.error.backgroundColor'));
});
var ClearButton = styled(Icon).attrs({
  name: 'DELETE'
})(_templateObject7(), themeGet('input.clearButton.hover.color'), themeGet('input.clearButton.active.color'));
export var IconWrap = styled.span(_templateObject8(), right, left);
HtmlInput.defaultProps = {
  size: 'default'
};
export var Input =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
      disabled = _ref.disabled,
      error = _ref.error,
      width = _ref.width,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      allowClear = _ref.allowClear,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["size", "disabled", "error", "width", "prefix", "suffix", "allowClear", "value", "defaultValue", "onChange"]);

  var _useState = useState(value || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var onTextChange = useCallback(function (event) {
    if (typeof onChange === 'function') {
      onChange(event);
    }

    if (value === undefined) {
      setCurrentValue(event.target.value || '');
    }
  }, [onChange, setCurrentValue, value]);

  if (value !== undefined && value !== currentValue) {
    setCurrentValue(value);
  }

  return (
    /*#__PURE__*/
    React.createElement(StyledInput, {
      width: width
    },
    /*#__PURE__*/
    React.createElement(IconWrap, {
      left: "8px"
    }, prefix),
    /*#__PURE__*/
    React.createElement(HtmlInput, _extends({
      py: 0,
      pl: prefix ? '32px' : '8px',
      pr: suffix || allowClear ? '32px' : '8px',
      size: size,
      disabled: disabled,
      error: error
    }, props, {
      onChange: onTextChange,
      value: currentValue,
      ref: ref
    })),
    /*#__PURE__*/
    React.createElement(IconWrap, {
      right: "8px"
    }, allowClear ?
    /*#__PURE__*/
    React.createElement(ClearButton, {
      onClick: onTextChange
    }) : suffix))
  );
});
Input.defaultProps = {
  allowClear: false,
  defaultValue: '',
  width: '100%'
};